import { useSearch } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import type { Company } from '@/stores/auth'

/** 현재 창의 회사 객체 — URL ?company=id 를 사용자 회사목록에서 조회.
 *  회사가 URL 에 없거나 목록에 없으면 null. (이름 표시·회사별 로직에 사용) */
export function useCurrentCompany(): Company | null {
  const search = useSearch({ strict: false }) as { company?: number }
  const companyId = search.company
  const { data: companies = [] } = useQuery({
    queryKey: ['companies', ''],
    queryFn: () => api<Company[]>('/api/companies?q='),
    enabled: !!companyId,
    staleTime: 60_000,
  })
  return companyId ? companies.find((c) => c.id === companyId) ?? null : null
}
